<script>
import MetisMenu from 'metismenujs/dist/metismenujs'

import { authComputed } from '@state/helpers'
import store from '@state/store'

/**
 * Application menu component
 */
export default {
  components: {},
  props: {
    mode: {
      type: String,
      default: 'vertical',
    },
    menuProps: {
      type: Array,
    },
  },
  data() {
    return {
      menuItems: this.menuProps,
    }
  },
  computed: {
    ...authComputed,
  },
  mounted: function() {
    // eslint-disable-next-line no-unused-vars
    this.menuItems = this.menuProps
    var menuRef = null

    if (this.mode === 'horizontal') {
      menuRef = new MetisMenu('#side-menu').on('shown.metisMenu', function(
        event
      ) {
        window.addEventListener('click', function menuClick(e) {
          if (!event.target.contains(e.target)) {
            menuRef.hide(event.detail.shownElement)
            window.removeEventListener('click', menuClick)
          }
        })
      })
    } else {
      menuRef = new MetisMenu('#side-menu')
    }

    var links = document.getElementsByClassName('side-nav-link-ref')
    var matchingMenuItem = null
    // let menuItemEl = null
    for (var i = 0; i < links.length; i++) {
      if (window.location.pathname === links[i].pathname) {
        matchingMenuItem = links[i]
        break
      }
    }

    if (matchingMenuItem === null) {
      var pathname = window.location.pathname.split('/')

      for (var j = 0; j < links.length; j++) {
        if (links[j].pathname.includes(pathname[2])) {
          matchingMenuItem = links[j]
          break
        }
      }
    }

    const activeClass = this.mode === 'horizontal' ? 'active' : 'mm-active'
    const dropdownActiveClass =
      this.mode === 'horizontal' ? 'active' : 'mm-show'

    if (matchingMenuItem) {
      matchingMenuItem.classList.add('active')
      var parent = matchingMenuItem.parentElement

      /**
       * TODO: This is hard coded way of expading/activating parent menu dropdown and working till level 3.
       * We should come up with non hard coded approach
       */
      if (parent) {
        parent.classList.add(activeClass)
        const parent2 = parent.parentElement

        if (parent2) {
          parent2.classList.add(dropdownActiveClass)
        }
        const parent3 = parent2.parentElement
        if (parent3) {
          parent3.classList.add(activeClass)
          var childAnchor = parent3.querySelector('.has-dropdown')
          if (childAnchor) childAnchor.classList.add('active')
        }

        const parent4 = parent3.parentElement
        if (parent4) parent4.classList.add(dropdownActiveClass)
        const parent5 = parent4.parentElement
        if (parent5) parent5.classList.add(activeClass)
      }
    }
  },
  methods: {
    /**
     * Returns true or false if given menu item has child or not
     * @param item menuItem
     */
    hasItems(item) {
      return item && item.children !== undefined
        ? item.children.length > 0
        : false
    },

    checkAuthorized(item) {
      var user = store.getters['auth/getUser']

      // Guard clause: Pastikan user dan permissions ada
      if (!user || !user.permissions) return false

      // 1. Cek izin untuk item utama menggunakan && tradisional
      var hasParentAccess =
        item.key &&
        user.permissions[item.key] &&
        user.permissions[item.key].view === true

      // 2. Jika item memiliki children, cek izin semua sub-item-nya
      if (item.children && item.children.length > 0) {
        var hasChildAccess = item.children.some(function(child) {
          return (
            child.key &&
            user.permissions[child.key] &&
            user.permissions[child.key].view === true
          )
        })

        return hasChildAccess
      }

      // 3. Jika tidak punya children, kembalikan hasil cek item utama
      return hasParentAccess
    },
  },
}
</script>

<template>
  <!--- Sidemenu -->

  <ul id="side-menu" class="metismenu">
    <template v-for="item in menuItems">
      <li
        v-if="item.name !== null"
        v-show="checkAuthorized(item)"
        :key="`item-${item.name}`"
        class="side-nav-title side-nav-item"
      >
        <p v-if="item.header" class="menu-title mb-0">{{ item.header }}</p>

        <a
          v-if="hasItems(item)"
          href="javascript:void(0);"
          class="side-nav-link"
        >
          <feather v-if="item.icon" :type="item.icon"></feather>
          <span>{{ item.name }}</span>
          <span class="menu-arrow"></span>
        </a>

        <router-link
          v-if="!hasItems(item)"
          tag="a"
          :to="`${item.path}`"
          class="side-nav-link side-nav-link-ref"
        >
          <feather v-if="item.icon" :type="item.icon"></feather>
          <span>{{ item.name }}</span>
          <span
            v-if="item.badge"
            :class="
              'badge badge-' + item.badge.varient + ' float-right font-size-11'
            "
            >{{ item.badge.text }}</span
          >
        </router-link>

        <ul v-if="hasItems(item)" class="nav-second-level">
          <li
            v-for="subitem in item.children"
            v-show="checkAuthorized(subitem)"
            :key="`sub-item-${subitem.name}`"
            :class="{ 'side-nav-item': hasItems(subitem) }"
          >
            <a
              v-if="hasItems(subitem)"
              href="javascript:void(0);"
              class="side-nav-link-a-ref"
            >
              {{ subitem.name }}
              <span class="menu-arrow"></span>
            </a>

            <router-link
              v-if="!hasItems(subitem)"
              tag="a"
              :to="`${item.path}/${subitem.path}`"
              class="side-nav-link-ref"
              >{{ subitem.name }}</router-link
            >

            <ul
              v-if="hasItems(subitem)"
              class="nav-third-level"
              aria-expanded="false"
            >
              <li
                v-for="subSubitem in subitem.children"
                :key="`sub-sub-item-${subSubitem.name}`"
              >
                <router-link
                  tag="a"
                  :to="`${item.path}/${subitem.path}/${subSubitem.path}`"
                  class="side-nav-link-ref"
                  >{{ subSubitem.name }}</router-link
                >
              </li>
            </ul>
          </li>
        </ul>
      </li>
    </template>
  </ul>

  <!-- End Sidebar -->
</template>
